'use client';

import HomeTopSection from '@egalite/ui/IncluiPCD/JobSearch/HomeTopSection';
import { FC } from 'react';

const noop = () => {};

/**
 * Fallback do <Suspense> da busca na home. Renderiza exatamente o mesmo
 * HomeTopSection que o HomeSearch em modo headerOnly, porém com props
 * inertes — garantindo altura/layout idênticos ao conteúdo final e, com
 * isso, zero layout shift (CLS) quando o HomeSearch é hidratado.
 */
const HomeSearchFallback: FC = () => {
	return (
		<HomeTopSection
			cities={[]}
			states={[]}
			locationDisabled={false}
			search={''}
			selectedCity={''}
			selectedState={''}
			onSearch={e => e.preventDefault()}
			setSearch={noop}
			setSelectedCity={noop}
			setSelectedState={noop}
			showFilterButton={false}
			onFilterButtonPress={noop}
		/>
	);
};

export default HomeSearchFallback;
